import Translate from '../Shared/Translate';

export default function ActionBtnText(props) {
    return (
        <div class="text-center btn-text">
        <span className="cursor-pointer hin-h6 text-uppercase text-gradient" onClick={props.onClick}><Translate textKey={props.textKey} /></span>      
        </div>
    )
}
